export { default as BrandInfoModal } from "./BrandInfoModal";
export * from "./NewBrandInfoModal";
